/* eslint-disable jira/filename-case */
import type { NavigationProject } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-jpd-nav-views/src/common/types.tsx';
import type { GetViewUrl } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-jpd-nav-views/src/controllers/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const getViewUrl: GetViewUrl<NavigationProject> = ({ container, view }) => {
	const viewSlug = fg('jpd-aurora-view-uuid-migration') ? view.id : view.polarisId;
	return `/jira/polaris/projects/${container.projectKey}/ideas/view/${viewSlug}`;
};
